define('fukit/helpers/roles.helper',['require','exports','module','underscore','backbone.radio','../config'],function(require, exports, module) {
  //prettier-ignore
  var _      = require('underscore'),
      Radio  = require('backbone.radio'),
      config = require('../config');

  var RolesHelper = {
    /**
     *  Returns an array of roles granted to the user currently logged in
     *
     * @return {Array} of roles assigned to the authenticated user
     */
    getUserRoles: function() {
      return Radio.channel('evicommon.authenticationService').request('roles');
    },

    /**
     *  Compares an array of required role strings against a user's granted roles
     *  and determines if the user has at least one of those roles granted.
     *  If no array of required roles has been defined, we assume roles are sufficient.
     *
     * @param {Array} roles of role strings or an array of arrays of role strings
     * @return {Boolean}
     */
    evaluateRoleArrayAgainstUserRoles: function(roles) {
      return _.intersection(roles, this.getUserRoles()).length > 0;
    },

    /**
     *  Takes a roles options array and will determine if it is a simple or
     *  compound role option, and evaluate the roles accordingly.

     *  If passed an array of strings (simple roles), only one of the strings
     *  needs to match a string in the array of assigned user roles
     *
     *  If passed an array of arrays (compound roles), each array must be evaluated
     *  as an allowed simple role assignment to be sufficient (in essence, an AND condition for each array).
     *
     * @param {Array} rolesOptions Array of role strings or an array of arrays of role strings
     * @return {Boolean}
     */
    evaluateRolesOptions: function(rolesOptions) {
      var isAllowed = false;

      if (_.isArray(rolesOptions) && _.isArray(rolesOptions[0])) {
        // An array of arrays is a compound role, each sub array must contain at least user role for the view to be allowed
        isAllowed = this.evaluateCompoundRoles(rolesOptions);
      } else if (!_.isUndefined(rolesOptions) || !_.isNull(rolesOptions)) {
        isAllowed = this.evaluateRoleArrayAgainstUserRoles(rolesOptions);
      }

      return isAllowed;
    },

    /**
     *  Compares array of arrays of role strings, each array must be evaluated
     *  as sufficient (in essence, an AND condition for each array).
     *
     * @param {Array} rolesOptions array of arrays of role strings
     * @return {Boolean}
     */
    evaluateCompoundRoles: function(rolesOptions) {
      var roleEvaluations = [];

      _.each(
        rolesOptions,
        function(roles) {
          roleEvaluations.push(this.evaluateRoleArrayAgainstUserRoles(roles));
        },
        this
      );

      return roleEvaluations.length === _.compact(roleEvaluations).length;
    },

    /**
     *  Will take an array of authorization configuration objects ( { filter: filterFunction(), roles: RolesArray}), and return
     *  the first roles array that the filter returns true.
     *
     *  Filters ideally should be mutually exclusive conditions, save for the last declared filter which always returns true
     *  and acts as a default option for the view.
     *
     * @param {Array} optionsArray Array of authorization configuration objects
     * @param {Object} context context in which the filter should be evaluated
     * @return {Array} Array of role strings
     */
    getMatchedOption: function(optionsArray, context) {
      var matchedOption,
        matched = false;

      if (!_.isArray(optionsArray)) {
        optionsArray = [optionsArray];
      }

      _.each(optionsArray, function(authorizationOptions) {
        if (!authorizationOptions) {
          return;
        }

        if (_.isArray(authorizationOptions)) {
          matchedOption = _.find(authorizationOptions, function(optionItem) {
            var noFilter = !_.isFunction(optionItem.filter);
            if ((noFilter || optionItem.filter.call(context || this)) && !matched) {
              return true;
            }
          });
        } else {
          var noFilter = !_.isFunction(authorizationOptions.filter);
          if ((noFilter || authorizationOptions.filter.call(context || this)) && !matched) {
            matched = true;
            matchedOption = authorizationOptions;
          }
        }
      });

      return matchedOption;
    },

    /**
     *  Will evaluate if the session user has a single role
     *
     * @param {String} role string
     * @return {Boolean} true if the session user has the role
     */
    hasRole: function(role) {
      return RolesHelper.hasEachRole([role]);
    },

    /**
     *  Will evaluate an array of roles and determine if all passed roles have been assigned to a user
     *
     * @param {Array} roles array of role strings
     * @return {Boolean} true if and only if each of the roles passed in have been assigned to the user
     */
    hasEachRole: function(roles) {
      if (roles.length === 0) {
        return false;
      } else {
        var commonRoles = _.intersection(roles, this.getUserRoles());

        return roles.length === commonRoles.length;
      }
    },

    /**
     *  Given a role prefix and an array of permission strings, will calculate whether a user has been assigned
     *  ONLY the roles for those permissions for the namespace of a given prefix, i.e., given the role prefix 'PERSON_PROFILE_', and
     *  permission array of ['READ','CREATE'], will determine if the user has been assigned only 'PERSON_PROFILE_READ'
     *  and 'PERSON_PROFILE_CREATE'
     *
     * @param {String} rolePrefix string defining the namespace of a permissions grouping
     * @param {Array} includedPerms an array of permmission strings
     * @return {Boolean} true if and only if a user has been assigned each permission in the given role namespace
     */
    hasOnlyNamespacedRoles: function(rolePrefix, includedPerms) {
      var self = this;
      var buildRoles = function(prefix, perms) {
        var roles = [];

        _.each(perms, function(perm) {
          roles.push(prefix + perm);
        });

        return roles;
      };

      //prettier-ignore
      var includedRoles = buildRoles(rolePrefix, includedPerms),
          excludedRoles = buildRoles(rolePrefix, _.difference(config.get('ROLE_PERMISSION_SUFFIXES'), includedPerms));

      return this.hasEachRole(includedRoles) && !this.evaluateRoleArrayAgainstUserRoles(excludedRoles);
    },
  };

  module.exports = RolesHelper;
});

